export const FontWeight = {
  regular: 400,
  medium: 500,
  bold: 700,
};

